import styled from 'styled-components'

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`

export default Centered
